export const documentProps = {
  title: 'ROI Calculator — See What Inefficiency Is Costing You',
  description:
    'Three free calculators: Automation Savings, Downtime Revenue Risk, and Technology Bill Audit. Find out exactly what manual processes are costing your business each year.',
};
